module.exports = __webpack_public_path__ + "static/media/vorxis-4.3d5edf05.jpg";